// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: any,
    options: {
        scripts: array,
    },
};

export default class Piksel extends Component<Props> {
    componentDidMount() {
        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts) loadScripts(customScripts);
        else {
            const script = document.createElement('script');
            script.src = `https://player.piksel.com/p/${
                this.props.content
            }?embed=js`;
            script.id = `piksel-script-${this.props.content}`;
            if (document.body) {
                document.body.appendChild(script);
            }
        }
    }

    componentWillUnmount() {
        const script = document.getElementById(
            `piksel-script-${this.props.content}`
        );
        if (script) {
            script.outerHTML = '';
        }
    }

    render() {
        return <div id="piksel" />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Piksel.js